/**
 * Where day-NN.json files are served from. In development this points to the
 * Vite `public/data` folder; in production, set VITE_DATA_BASE_URL to the
 * Cloudflare R2 (or other CDN) bucket origin in `.env.production`.
 *
 * No trailing slash — the API layer appends `/day-NN.json`.
 */
export const DATA_BASE_URL: string = (
  import.meta.env.VITE_DATA_BASE_URL ?? "/data"
).replace(/\/+$/, "");
